import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";

import { FirebaseDatabaseRootDataProvider } from "./context/FirebaseDatabaseRootDataContext";
import { ThemeProvider, ThemeContext } from "./context/ThemeContext";
import HomePage from "./Pages/HomePage/HomePage";
import ProjectPage from "./Components/Projects/ProjectDetailed/ProjectPage";
import "./App.css";

function ThemedApp() {
  const { theme } = useContext(ThemeContext);

  return (
    <MantineProvider
      withGlobalStyles
      withNormalizeCSS
      theme={{
        colorScheme: theme,
        globalStyles: () => ({
          'body, .home-page-container': {
            backgroundColor: 'var(--bg-color) !important',
            color: 'var(--text-color) !important',
          },
        }),
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/project/:projectId" element={<ProjectPage />} />
        </Routes>
      </Router>
    </MantineProvider>
  );
}

function App() {

  return (
    <ThemeProvider>
      <FirebaseDatabaseRootDataProvider>
        <ThemedApp />
      </FirebaseDatabaseRootDataProvider>
    </ThemeProvider>
  );
}

export default App;
